import * as React from "react";

export const AppContext = React.createContext({
  connect: () => {},
  connectWithMicrosoft: () => {},
  disconnect: () => {},
  getConnectionToken: () => {},
  getAuthMethod: () => {},
  getMicrosoftUserInfo: () => {},
  isConnected: () => {},
  navigation: {
    goToLogin: () => {},
    goToMain: () => {}
  },
  showHttpErrorMessage: () => {},
  forceLogoutDueToAuthFailure: () => {},
  cancelRequests: () => {},
  addRequestCanceller: () => {},
  setCanCreatePartner: () => {},
  setUserCompanies: () => {},
  showTopBarMessage: () => {},
  hideTopBarMessage: () => {},
  showPartnerCreatedMessage: false,
  showEnrichmentInfoMessage: false,
  canCreatePartner: true,
  userCompanies: [],
  pageDisplayed: 0,
  loginErrorMessage: "",
  cookies: "",
  EnrichmentInfo: {},
  // Compose mode support
  isComposeMode: false,
  composeLogTargets: [],
  addComposeLogTarget: () => {},
  removeComposeLogTarget: () => {},
  clearComposeLogTargets: () => {},
  enableLogOnSend: false,
  setEnableLogOnSend: () => {}
});

export default AppContext;
